import { render, staticRenderFns } from "./hoursModal.vue?vue&type=template&id=a3af85dc&"
import script from "./hoursModal.vue?vue&type=script&lang=js&"
export * from "./hoursModal.vue?vue&type=script&lang=js&"
import style0 from "./hoursModal.vue?vue&type=style&index=0&id=a3af85dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QForm,QIcon,QTooltip,QToggle,QCheckbox,QSelect,QSpace,QBtn,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QForm,QIcon,QTooltip,QToggle,QCheckbox,QSelect,QSpace,QBtn,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
